<h1 matDialogTitle>RCS Account Payment</h1>

<mat-dialog-content>
  <form class="dynamic-form" [formGroup]="rcsForm" style="width: 100%">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">
      <mat-form-field fxFlex="40" width="100%">
        <mat-label>RCS Card Number</mat-label>
        <input matInput style="text-align: right;" type="text" minlength="19" maxlength="19"
          formControlName="cardNumber" autocomplete="new-password">
      </mat-form-field>
    </div>
  </form>

  <app-pos-capture-payment (paymentChanged)="paymentChanged($event)" [paymentType]="data.paymentType"
    [amountOutstanding]="0">
  </app-pos-capture-payment>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button [disabled]="!rcsForm.valid || !formValid || busy" mat-button (click)="save()">Save</button>
</mat-dialog-actions>
